import { DebouncedInputSearch } from '@components/debounced-input-search';
import { DEBOUNCE_VARIANT_LIGHT } from '@components/debounced-input-search/src/debounced-input-search.type';
import { Loader } from '@components/loader';
import { Modal } from '@components/modals';
import { ModalStickyFooter } from '@components/modals/modal-sticky-footer';
import { ModalStickyHeader } from '@components/modals/modal-sticky-header';

import { SearchItemModalProps } from './search-item-modal.type';

export const SearchItemModal = ({
  children,
  isOpen,
  title,
  loading,
  showCloseIconButton,
  placeholder,
  searchTerm,
  buttonSecondaryText,
  isButtonSecondaryDisabled,
  buttonPrimaryText,
  isButtonPrimaryDisabled,
  debounceInputVariant = DEBOUNCE_VARIANT_LIGHT,
  handleClose,
  handleSearch,
  handlePrimaryButton,
  handleSecondaryButton,
  beforeEnter,
  beforeLeave,
  afterEnter,
  afterLeave,
}: SearchItemModalProps) => {
  const isFooterVisible = !!buttonPrimaryText || !!buttonSecondaryText;

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      variant='md'
      beforeEnter={beforeEnter}
      beforeLeave={beforeLeave}
      afterEnter={afterEnter}
      afterLeave={afterLeave}>
      <div className='flex justify-end flex-col'>
        <div className='sticky top-0 z-50 w-full'>
          <ModalStickyHeader
            handleClose={showCloseIconButton ? handleClose : undefined}
            title={title}
            bordered={true}
          />
          <div className='px-4 sm:px-7 bg-primary pt-8'>
            <DebouncedInputSearch
              onChange={handleSearch}
              placeholder={placeholder}
              defaultValue={searchTerm}
              canDeleteSearch
              variant={debounceInputVariant}
              className='bg-primary'
            />
          </div>
        </div>
        <div className='pb-12 sm:pb-8 px-4 sm:px-7'>{loading ? <Loader /> : children}</div>
        {isFooterVisible && (
          <ModalStickyFooter
            isSubmitDisabled={isButtonPrimaryDisabled}
            isSecondaryButtonDisabled={isButtonSecondaryDisabled}
            onPrimaryButtonClick={handlePrimaryButton}
            onSecondaryButtonClick={handleSecondaryButton}
            primaryButtonText={buttonPrimaryText}
            secondaryButtonText={buttonSecondaryText}
          />
        )}
      </div>
    </Modal>
  );
};
